import { arrayOf, bool, shape, string } from 'prop-types'

export const footerCategoryLists = arrayOf(
  shape({
    categoryText: string.isRequired,
    items: arrayOf(
      shape({
        text: string.isRequired,
        link: string.isRequired,
        isCurrent: bool,
      })
    ).isRequired,
  })
)
